import React from 'react';
import { Link } from 'react-router-dom';

export default function OverOns() {
  return (
    <>
      {/* Page Hero */}
      <section className="bg-[#2d5e5e] pt-32 pb-16 text-center text-white">
        <div className="max-w-6xl mx-auto px-5">
          <h1 className="text-3xl font-bold mb-3">Over ons</h1>
          <p className="text-lg opacity-90">Leer ons beter kennen</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-5">
          {/* Main content grid */}
          <div className="grid md:grid-cols-3 gap-12 mb-12">
            <div className="md:col-span-2">
              <h2 className="text-2xl font-bold text-gray-900 mb-5">Wie zijn wij?</h2>
              <p className="text-lg text-gray-700 font-medium mb-4">
                PUUR Psychiatrie is een gespecialiseerd bureau dat zich volledig richt op het leveren van
                hoogwaardige psychiatrische zorg binnen GGZ-instellingen.
              </p>
              <p className="text-gray-600 mb-4 leading-relaxed">
                Wij bieden geen patiëntgerichte praktijk, maar ondersteunen instellingen die waarde hechten
                aan persoonlijke aandacht, professionele betrokkenheid en inhoudelijke versterking van hun behandelteam.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Onze psychiater is volledig BIG-geregistreerd en beschikt over ruime ervaring in zowel
                algemene volwassenenpsychiatrie als verslavingszorg. Dit stelt ons in staat om breed
                inzetbaar te zijn binnen verschillende GGZ-settings.
              </p>
            </div>

            <div>
              <div className="bg-gray-100 rounded-xl p-8">
                <h3 className="text-lg font-semibold text-gray-900 mb-5">Registraties</h3>
                <ul className="space-y-4">
                  <li className="flex items-center gap-4 pb-4 border-b border-gray-300">
                    <i className="fas fa-id-card text-xl text-[#2d5e5e]"></i>
                    <div>
                      <span className="block text-xs text-gray-600">BIG-nummer</span>
                      <span className="font-semibold text-gray-900">79913336601</span>
                    </div>
                  </li>
                  <li className="flex items-center gap-4 pb-4 border-b border-gray-300">
                    <i className="fas fa-building text-xl text-[#2d5e5e]"></i>
                    <div>
                      <span className="block text-xs text-gray-600">KvK-nummer</span>
                      <span className="font-semibold text-gray-900">88552489</span>
                    </div>
                  </li>
                  <li className="flex items-center gap-4">
                    <i className="fas fa-file-medical text-xl text-[#2d5e5e]"></i>
                    <div>
                      <span className="block text-xs text-gray-600">AGB-code</span>
                      <span className="font-semibold text-gray-900">03102142</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Two green blocks - same row, same height */}
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-[#2d5e5e] rounded-xl p-8 text-white flex flex-col">
              <h3 className="text-lg font-semibold mb-3 flex items-center gap-3">
                <i className="fas fa-star text-[#a4cc3a]"></i>
                Specialisatie: Verslavingszorg
              </h3>
              <p className="opacity-90 mb-5 leading-relaxed flex-grow">
                Naast algemene volwassenenpsychiatrie beschikken wij over uitgebreide expertise
                in poliklinische én klinische verslavingszorg.
              </p>
              <Link to="/contact" className="btn-accent inline-flex self-start">
                Contact opnemen
              </Link>
            </div>

            <div className="bg-[#2d5e5e] rounded-xl p-8 text-white flex flex-col">
              <h3 className="text-lg font-semibold mb-3">Interesse?</h3>
              <p className="opacity-90 mb-5 flex-grow">Neem vrijblijvend contact op voor een kennismaking.</p>
              <Link to="/offerte" className="btn-accent inline-flex self-start">
                Offerte aanvragen
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
